module.exports = __webpack_public_path__ + "img/blue-icon-en(3).8938419b.png";